import { render, staticRenderFns } from "./DraftPreInvoice.vue?vue&type=template&id=b4ada95a"
import script from "./DraftPreInvoice.vue?vue&type=script&lang=js"
export * from "./DraftPreInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports